import * as moment from 'moment';

export const isToDayDate = (date) => {
    if (!date) {
        return false;
    }
    return moment().isSame(date, 'days');
};
